import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { Container, Row, Col, Form, InputGroup } from 'react-bootstrap'
import { Helmet } from 'react-helmet-async'
import { FaMapMarkerAlt, FaPhone, FaWhatsapp, FaSearch, FaStore } from 'react-icons/fa'
import ImagePlaceholder from '../components/ImagePlaceholder'

const LOCATIONS = [
  { name: 'Academia Lions Lair', city: 'Itupeva', state: 'SP', address: 'Estr. Mun. Duilio Sai, 721', phone: '(11) 98880-3942', type: 'Revendedor' },
  { name: 'Cleanfoods Jaú', city: 'Jaú', state: 'SP', address: 'Rua Quintino Bocaiuva, 1455', phone: '(14) 98838-2023', type: 'Loja Própria' },
  { name: 'Cleanfoods Lençóis', city: 'Lençóis Paulista', state: 'SP', address: 'Rua Vinte e Oito de Abril, 773', phone: '(14) 99186-4299', type: 'Loja Própria' },
  { name: 'Casa Branca', city: 'Casa Branca', state: 'SP', address: 'Rua Coronel José Julio, 82', phone: '(19) 99874-2442', type: 'Revendedor' },
  { name: 'Revolution CT', city: 'Vargem Grande do Sul', state: 'SP', address: 'Avenida Teotônio Vilela, 135', phone: '(19) 99789-5027', type: 'Revendedor' },
  { name: 'Cleanfoods Rio Preto', city: 'Rio Preto', state: 'SP', address: 'Rua Rubião Junior, 2458', phone: '(17) 99196-7090', type: 'Loja Própria' },
  { name: 'Academia Evolution', city: 'Barretos', state: 'SP', address: 'Rua 50, Nº 0230', phone: '(17) 98205-4146', type: 'Revendedor' },
  { name: 'Armazem do Corpo', city: 'Barretos', state: 'SP', address: 'Rua Vinte e Seis, 1114', phone: '(17) 98103-4277', type: 'Revendedor' },
  { name: 'Vila Sette', city: 'Jaboticabal', state: 'SP', address: 'Rua Lions Internacional, 71', phone: '(17) 99764-9606', type: 'Revendedor' },
  { name: 'Limeira', city: 'Limeira', state: 'SP', address: 'Avenida Maria Buzolin, 752', phone: '(19) 98186-6582', type: 'Revendedor' },
  { name: 'Olympo Suplementos', city: 'Itapetininga', state: 'SP', address: 'Rua Doutor Virgilio de Rezende, 1425', phone: '(15) 98145-8653', type: 'Revendedor' },
  { name: 'Nutrimanía', city: 'Sorocaba', state: 'SP', address: 'Rua Emygdia Campolim, 45', phone: '(15) 99131-5856', type: 'Revendedor' },
  { name: 'Panobianco Dom Aguirre', city: 'Sorocaba', state: 'SP', address: 'Av. Juvenal de Campos', phone: '(15) 99831-0808', type: 'Revendedor' },
  { name: 'Panobianco JJ Lacerda', city: 'Sorocaba', state: 'SP', address: 'Avenida Joaquim de Lacerda, 947', phone: '(15) 99257-2744', type: 'Revendedor' },
  { name: 'X3 Suplementos', city: 'Sorocaba', state: 'SP', address: 'Avenida Ipanema, 3798', phone: '(15) 99767-2269', type: 'Revendedor' },
  { name: 'Piraju', city: 'Piraju', state: 'SP', address: 'Rua Major Mariano, 137', phone: '(14) 99842-8978', type: 'Revendedor' },
  { name: 'Physical', city: 'Barueri', state: 'SP', address: 'Avenida Trindade, 344', phone: '(11) 93385-5794', type: 'Revendedor' },
  { name: 'Physical', city: 'Cotia', state: 'SP', address: 'Avenida Nossa Senhora de Fatima, 558', phone: '(11) 93440-0334', type: 'Revendedor' },
  { name: 'Physical', city: 'Granja Vianna', state: 'SP', address: 'Rua Mesopotamia, 109', phone: '(11) 94474-1236', type: 'Revendedor' },
  { name: 'Fithouse', city: 'Vila Olímpia', state: 'SP', address: 'Avenida Doutor Cardoso de Melo, 1290', phone: '(11) 99418-4274', type: 'Revendedor' },
  { name: 'Hora da Fome', city: 'Pari', state: 'SP', address: 'Avenida Pedroso da Silveira, 212', phone: '(11) 97867-0739', type: 'Revendedor' },
  { name: 'Higashi Suplementos', city: 'Araçoiaba', state: 'SP', address: 'Rua Professor Toledo, 105', phone: '(15) 99791-5390', type: 'Revendedor' },
  { name: 'Cleanfoods SP', city: 'Ipiranga', state: 'SP', address: 'Rua Silva Bueno, 894', phone: '(11) 91099-3953', type: 'Loja Própria' },
  { name: 'Embu das Artes', city: 'Embu das Artes', state: 'SP', address: 'Avenida Elias Yazbek, 1276', phone: '(11) 98555-9748', type: 'Revendedor' },
  { name: 'Emporio Ponto Saudavel', city: 'Embu das Artes', state: 'SP', address: 'Avenida João Paulo II, 1292', phone: '(11) 99347-1873', type: 'Revendedor' },
  { name: 'Ariel Suplementos', city: 'Itatiba', state: 'SP', address: 'Rua Octaviano Pellizzer, 272', phone: '(19) 98426-9446', type: 'Revendedor' },
  { name: 'Muscleworld', city: 'Campinas', state: 'SP', address: 'Rua Alfredo da Costa Figo, 255', phone: '(22) 99853-7385', type: 'Revendedor' },
  { name: 'Musclefit', city: 'Piracicaba', state: 'SP', address: 'Avenida Piracicamirim, 2455', phone: '(19) 98983-5286', type: 'Revendedor' },
  { name: 'Hangfit', city: 'Vila Maria', state: 'SP', address: 'Rua Dom Luis Felipe de Orleans, 840', phone: '(11) 96373-8705', type: 'Revendedor' },
  { name: '220 Nutrition Biagi', city: 'Ribeirão Preto', state: 'SP', address: 'Avenida Maurilio Biagi, 1450', phone: '(16) 99644-4246', type: 'Revendedor' },
  { name: '220 Nutrition Shopping Iguatemi', city: 'Ribeirão Preto', state: 'SP', address: 'Avenida Luiz Eduardo de Toledo Prado, 900', phone: '(16) 99739-9909', type: 'Revendedor' },
  { name: '220 Nutrition Ribeirão Shopping', city: 'Ribeirão Preto', state: 'SP', address: 'Avenida Coronel Fernando Ferreira Leite, 1540', phone: '(16) 99739-4449', type: 'Revendedor' },
  { name: 'Its Time Nutrition', city: 'São Carlos', state: 'SP', address: 'Rua Quinze de Novembro, 1751', phone: '(16) 99253-1800', type: 'Revendedor' },
  { name: 'Growfit Unidade 1', city: 'São Carlos', state: 'SP', address: 'Rua Padre Teixeira, 3530', phone: '(16) 3364-3130', type: 'Revendedor' },
  { name: 'Growfit Unidade 2', city: 'São Carlos', state: 'SP', address: 'Avenida São Carlos, 526', phone: '(16) 3368-8864', type: 'Revendedor' },
  { name: 'Registro', city: 'Registro', state: 'SP', address: 'Avenida Clara Gianotti de Souza, 116', phone: '(13) 99623-3516', type: 'Revendedor' },
  { name: 'Bistrofit', city: 'Piqueri', state: 'SP', address: 'Rua Coronel Bento Bicudo, 1038', phone: '(11) 95941-7611', type: 'Revendedor' },
  { name: 'São Roque', city: 'São Roque', state: 'SP', address: 'Avenida Antonio Dias Bastos, 21, sala 20', phone: '(11) 94285-5110', type: 'Revendedor' },
  { name: 'Shape+', city: 'São Paulo', state: 'SP', address: 'Rua Tito, 745, loja 4B', phone: '(11) 95903-4905', type: 'Revendedor' },
  { name: 'Cleanfoods Moema', city: 'Moema', state: 'SP', address: 'Alameda Macieira da Maia, 37', phone: '(51) 9993-2145', type: 'Loja Própria' },
  { name: 'Tambaú', city: 'Tambaú', state: 'SP', address: 'Rua Étore Martineli, 188', phone: '(19) 99850-2852', type: 'Revendedor' },
  { name: 'São Paulo (Zona Leste)', city: 'São Paulo', state: 'SP', address: 'Rua Pedroso da Silva, 504', phone: '(11) 2585-3318', type: 'Revendedor' },
  { name: 'Cleanfoods Americana', city: 'Americana', state: 'SP', address: 'Rua São Gonçalo, 40, bloco C, ap. 131', phone: '(19) 99107-6331', type: 'Loja Própria' },
  { name: 'Jardinópolis', city: 'Jardinópolis', state: 'SP', address: 'Rua Cel. Clementino, 91', phone: '(16) 99388-1825', type: 'Revendedor' },
  { name: 'Thor Suplementos Sorocaba', city: 'Sorocaba', state: 'SP', address: 'Avenida Getulio Vargas, 425', phone: '(15) 99665-8784', type: 'Revendedor' },
  { name: 'Academia Gaviões Metrô Sapopemba', city: 'São Paulo', state: 'SP', address: 'Avenida Sapopemba, 11449', phone: '(11) 94074-7584', type: 'Revendedor' },
  { name: 'Panobianco Terra Preta', city: 'Terra Preta', state: 'SP', address: 'Avenida Elydia Maria Pedroso, 75', phone: '(19) 98217-4474', type: 'Revendedor' },
  { name: 'Musclefit Americana', city: 'Americana', state: 'SP', address: 'Av. Carminé Feola, 1075', phone: '(19) 99010-1577', type: 'Revendedor' },
  { name: 'Musclefit Indaiatuba', city: 'Indaiatuba', state: 'SP', address: 'Rua Claudio Dal Canton, 98', phone: 'Não informado', type: 'Revendedor' },
  { name: 'Panobianco Campinas', city: 'Campinas', state: 'SP', address: 'Avenida Mirandópolis, 930', phone: '(19) 98341-1326', type: 'Revendedor' },
  { name: 'Casa do Churrasco Cafelandia', city: 'Cafelândia', state: 'SP', address: 'Rua Francisco Gonzales Jaren, 377', phone: '(14) 99902-5523', type: 'Revendedor' },
]

export default function PontosDeVenda() {
  const [search, setSearch] = useState('')

  const filtered = LOCATIONS.filter(
    (loc) =>
      loc.name.toLowerCase().includes(search.toLowerCase()) ||
      loc.city.toLowerCase().includes(search.toLowerCase()),
  )

  return (
    <>
      <Helmet>
        <title>Pontos de Venda – Clean Foods Brasil</title>
        <meta name="description" content="Encontre um ponto de venda Clean Foods Brasil perto de você. Revendedores autorizados em todo o interior de São Paulo." />
      </Helmet>

      {/* ===== PAGE HERO ===== */}
      <div style={{ paddingTop: 72 }}>
        <section className="page-hero">
          <Container>
            <Row>
              <Col lg={8}>
                <p className="text-cf-yellow fw-bold text-uppercase small mb-2" style={{ letterSpacing: 2 }}>
                  Onde encontrar
                </p>
                <h1 className="section-title mb-0">
                  Pontos de <span className="highlight">Venda</span>
                </h1>
                <hr className="section-divider" />
                <p style={{ maxWidth: 560, lineHeight: 1.8 }}>
                  Encontre um revendedor autorizado Clean Foods Brasil perto de você em todo o interior
                  de São Paulo e região.
                </p>
              </Col>
            </Row>
          </Container>
        </section>
      </div>

      {/* ===== MAPA ===== */}
      <section className="section-padding bg-cf-black">
        <Container>
          <Row className="gy-5">
            <Col lg={8}>
              <p className="text-cf-yellow fw-bold text-uppercase small mb-2" style={{ letterSpacing: 2 }}>
                Mapa de Cobertura
              </p>
              <h2 className="section-title mb-0">
                Nossa <span className="highlight">Rede</span>
              </h2>
              <hr className="section-divider" />
              <ImagePlaceholder height="420px" label="Mapa com pontos de venda" />
            </Col>
            <Col lg={4}>
              <div className="cf-card p-4 h-100">
                <div className="d-flex align-items-center gap-3 mb-4">
                  <div className="cf-card-icon flex-shrink-0" style={{ width: 48, height: 48, fontSize: '1.2rem' }}>
                    <FaStore />
                  </div>
                  <div>
                    <h5 className="fw-bold mb-0">Rede em crescimento</h5>
                    <p className="mb-0" style={{ fontSize: '0.85rem' }}>Interior de São Paulo e região</p>
                  </div>
                </div>
                <p style={{ fontSize: '0.9rem', lineHeight: 1.7 }}>
                  Nossa rede de revendedores credenciados está em constante crescimento. Estamos presentes
                  em academias, empórios, suplementistas e outros estabelecimentos voltados à saúde e
                  performance.
                </p>
                <hr style={{ borderColor: 'var(--cf-border)' }} />
                <p style={{ fontSize: '0.9rem' }}>
                  Não encontrou um ponto perto de você? Seja o primeiro revendedor da sua cidade!
                </p>
                <Link to="/seja-revendedor" className="btn btn-cf-yellow w-100">
                  Seja um Revendedor
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* ===== LISTA DE PONTOS ===== */}
      <section className="section-padding bg-cf-dark">
        <Container>
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-end gap-3 mb-5">
            <div>
              <p className="text-cf-yellow fw-bold text-uppercase small mb-2" style={{ letterSpacing: 2 }}>
                Revendedores Autorizados
              </p>
              <h2 className="section-title mb-0">
                Encontre seu <span className="highlight">ponto</span>
              </h2>
              <hr className="section-divider mb-0" />
            </div>
            {/* Search */}
            <InputGroup style={{ maxWidth: 300 }}>
              <InputGroup.Text
                style={{ background: 'var(--cf-gray)', border: '1px solid var(--cf-border)', color: 'var(--cf-yellow)' }}
              >
                <FaSearch />
              </InputGroup.Text>
              <Form.Control
                placeholder="Buscar por nome ou cidade..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                style={{
                  background: 'var(--cf-gray)',
                  border: '1px solid var(--cf-border)',
                  color: 'var(--cf-text)',
                }}
              />
            </InputGroup>
          </div>

          {filtered.length === 0 ? (
            <div className="text-center py-5">
              <FaMapMarkerAlt size={40} className="text-cf-yellow mb-3 opacity-50" />
              <p style={{ color: 'var(--cf-muted)' }}>Nenhum ponto encontrado para "{search}".</p>
            </div>
          ) : (
            <Row className="gy-3">
              {filtered.map((loc, i) => (
                <Col key={i} md={6} lg={4}>
                  <div className="location-card h-100">
                    <div className="d-flex justify-content-between align-items-start mb-2">
                      <h5 className="fw-bold mb-0" style={{ fontSize: '0.97rem', lineHeight: 1.3 }}>
                        {loc.name}
                      </h5>
                      <span
                        className="ms-2 flex-shrink-0 product-badge"
                        style={{
                          background: loc.type === 'Loja Própria' ? 'var(--cf-yellow)' : 'var(--cf-gray)',
                          color: loc.type === 'Loja Própria' ? 'var(--cf-black)' : 'var(--cf-muted)',
                          fontSize: '0.7rem',
                        }}
                      >
                        {loc.type}
                      </span>
                    </div>
                    <p className="d-flex align-items-center gap-2 mb-1" style={{ fontSize: '0.85rem' }}>
                      <FaMapMarkerAlt className="text-cf-yellow flex-shrink-0" />
                      {loc.address} – {loc.city}/{loc.state}
                    </p>
                    <p className="d-flex align-items-center gap-2 mb-0" style={{ fontSize: '0.85rem' }}>
                      <FaPhone className="text-cf-yellow flex-shrink-0" />
                      {loc.phone === 'Não informado' ? (
                        <span className="mb-0">{loc.phone}</span>
                      ) : (
                        <a href={`tel:${loc.phone}`} className="footer-link mb-0">{loc.phone}</a>
                      )}
                    </p>
                  </div>
                </Col>
              ))}
            </Row>
          )}
        </Container>
      </section>

      {/* ===== WHATSAPP CTA ===== */}
      <section className="cta-section">
        <Container>
          <Row className="align-items-center gy-4">
            <Col lg={8}>
              <h2 className="cta-title mb-2">Não encontrou na sua cidade?</h2>
              <p className="cta-text mb-0">
                Entre em contato via WhatsApp e descubra como fazer um pedido ou como ser um revendedor
                na sua região.
              </p>
            </Col>
            <Col lg={4} className="text-lg-end">
              <a
                href="https://wa.me/5514991718448"
                target="_blank"
                rel="noreferrer"
                className="btn btn-lg fw-bold text-uppercase px-5 d-inline-flex align-items-center gap-2"
                style={{ background: 'var(--cf-black)', color: 'var(--cf-yellow)', borderRadius: 4 }}
              >
                <FaWhatsapp size={20} />
                Falar no WhatsApp
              </a>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  )
}
